import { render, staticRenderFns } from "./DetailsAside.vue?vue&type=template&id=66ddcd4c&scoped=true"
import script from "./DetailsAside.vue?vue&type=script&lang=ts"
export * from "./DetailsAside.vue?vue&type=script&lang=ts"
import style0 from "./DetailsAside.vue?vue&type=style&index=0&id=66ddcd4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66ddcd4c",
  null
  
)

export default component.exports